import React, { useState } from 'react';
import { useHistory } from "react-router-dom";
import { useSelector, useDispatch } from 'react-redux';
import { Divider, Modal, Loader, Button } from 'rsuite';
import * as actionsUser  from '../../../../../app/actions/user';
import {addExistingPolicy}  from '../../../../../app/common/services/fetch.service';
import {BackIcon} from '../../svg/iconsSvg';
import PayInstCarousel from './PayInstCarousel';
import { NuInsInputTextLabel } from '../../elements/inputFieldsLabel';
import { CheckBoxCustom } from '../../elements/inputFields';
import { InfoIcon } from '../../svg/iconsSvg';
import {store} from '../../../../../app/store';


const PayInstMain = ({onForward, onBack}) => {

    const history = useHistory();
    const dispatch = useDispatch();

    const auth = useSelector(state => state.auth);
    const {myPolicies} = useSelector(state=>state.userDetails);

    const [errorModal, setErrorModal] = useState(false);
    
    const [plate, setPlate] = useState(null);
    const [policy, setPolicy] = useState(null);
    const [acceptedCondition, setAcceptedCondition] = useState(null);

    const [showCondition, setShowCondition] = useState(false);
    const [showConfidentiality, setShowConfidentiality] = useState(false);

    const [loading, setLoading] = useState(false);

    const goBack = () => onBack(1);

    const onConfirmError = () => setErrorModal(false);

    const onCancel = () =>onForward(1);

    const goToLogin = () => history.push('/app/profile');

    const goToSignUp = () => history.push('/app/sign-up');
        
    const validateFields = () => {
        return plate && policy && acceptedCondition;
    }

    const submitHandler = async () => {
        if(!validateFields()) return;

        let policyFound;

        if(!myPolicies){
            setLoading(true);
            await dispatch(actionsUser.getMyPolicies());
            const policies = store.getState().userDetails?.myPolicies;
            policyFound = policies.find(docPolicy => docPolicy.policyId === policy.trim());
        } else {
            policyFound = myPolicies.find(docPolicy => docPolicy.policyId === policy.trim());
        }

        if(policyFound) {
            onForward(3, null, policyFound);
        } else {
            setLoading(true);

            let res;

            try{
                res = await addExistingPolicy(plate, policy);
            } catch(error) {
                console.log(error);
                setLoading(false);
            }

            //console.log(res.data)
            if(res && res.data?.success) {

                const insuranceId = res.data?.refNo;

                await dispatch(actionsUser.getMyPolicies());

                const policies = store.getState().userDetails?.myPolicies;

                const newPolicy = policies.find(docPolicy => docPolicy.insuranceId === insuranceId);

                onForward(3, null, newPolicy);
    
            } else {
                setErrorModal(true)
                setLoading(false);
            }
        }
    }

    return (
        <div className="steps_container" >
            <div  className="head">
                <div className="head-icon" style={{paddingLeft: '2rem'}} onClick={goBack}><BackIcon size={32}/></div>
                <h6 className="title" style={{marginRight: '48px'}}>ГРАЖДАНСКА ОТГОВОРНОСТ</h6>
            </div>
            <Divider />
            <h6 style={{alignSelf: 'center', margin: '1rem 0'}} >ПЛАЩАНЕ НА ВНОСКА ПО ПОЛИЦА</h6>
            <PayInstCarousel />
       
            <NuInsInputTextLabel validationType={"plate"} onChange={data => setPlate(data)} 
                        placeholder={"Регистрационен номер на МПС"} value={plate}
                        styles={{marginBottom: '20px', marginTop: '20px'}}/>
         
            <NuInsInputTextLabel onChange={data => setPolicy(data)} placeholder={"Номер на съществуваща полица"} 
                                 value={policy}  styles={{marginBottom: '20px'}}/> 
           
            <div className="steps_container-checkbox">
                <CheckBoxCustom onChange={data => setAcceptedCondition(data)} value={acceptedCondition}/>
                <div>Приемам <span className="link-pdf" onClick={()=>setShowCondition(true)}>Общите условия</span> на услугата и се запознах с <span onClick={()=>setShowConfidentiality(true)} className="link-pdf">Уведомлението за поверителност Информация за потребителя по чл. 325 от КЗ</span></div>
            </div>
            <Divider />
            <div className="steps_container-checkbox">
                <InfoIcon size="38" style={{marginLeft: '2px'}}/>
                <div>Регистриран застрахователен брокер с удостоверение № 801-ЗБ от 31.01.2022 г., издадено от КФН</div>
            </div>
            <Divider />
      
            <button className="nuIns-btn nuIns-btn-mxd nuIns-btn-main" type="submit" disabled={!validateFields()} onClick={submitHandler}>Продължи</button>
  

            {loading ? <Loader backdrop center size="lg"  speed="slow" /> : null}
              
            <Modal size="sm" show={showCondition || showConfidentiality} onHide={() => {setShowCondition(false); setShowConfidentiality(false);}}>
                <Modal.Header> </Modal.Header>
                <Modal.Body>
                    <iframe src={showCondition ?  "/files/Obshti-usloviya.pdf" : "/files/Uvedomlenie-za-poveritelnost.pdf"}  
                            style={{width:"550px", minHeight:"95vh"}} title="showCondition"/>
                </Modal.Body>
            </Modal>

            <Modal size="xs" className="nuins-ok-modal" show={errorModal} onHide={() => onConfirmError()}>
                <Modal.Body>
                    <p className="no-reg-data">Въведеният регистрационен номер и/или номер на полица е грешен. Провери въведените данни</p>    
                </Modal.Body>
                <Modal.Footer>
                    <Button onClick={() => onConfirmError()} >OK</Button>
                </Modal.Footer>
            </Modal>

            <Modal size="xs" className="nuins-choose-modal" show={!auth?.loginToken} onHide={() => onCancel()}>
                <Modal.Body>
                    <p className="no-reg-data">За да добавите нова полица, трябва да влезете в профила си</p>    
                </Modal.Body>
                <Modal.Footer>
                    <Button onClick={() => onCancel()} >Cancel</Button>
                    <Button onClick={() => goToSignUp()} >Създай профил</Button>
                    <Button onClick={() => goToLogin()} active>Влез в профил</Button>
                </Modal.Footer>
            </Modal>
        </div>
    )
}

export default PayInstMain;

